// Persist the same request key across ambiguous network failures and page reloads.
export async function checkoutRequestKey(scope, payload) {
  const digest = await window.crypto.subtle.digest("SHA-256", new TextEncoder().encode(JSON.stringify(payload)));
  const signature = Array.from(new Uint8Array(digest), byte => byte.toString(16).padStart(2, "0")).join("");
  const storageKey = `checkoutRequest:${scope}`;
  let saved;
  try { saved = JSON.parse(sessionStorage.getItem(storageKey)); } catch { /* replace corrupt state */ }
  if (saved?.signature === signature) return saved.key;
  const key = window.crypto.randomUUID();
  sessionStorage.setItem(storageKey, JSON.stringify({ signature, key }));
  return key;
}

export function clearCheckoutRequest(scope) {
  try { sessionStorage.removeItem(`checkoutRequest:${scope}`); } catch { /* Acknowledged orders must still complete if storage becomes unavailable. */ }
}
